import config from "../config";
import { storage } from "../utils/storage";

class Service {
  constructor() {
    this.domain = config.API_BASE_URL;
  }

  // Utility to combine URLs safely
  joinURL(baseURL, url) {
    return `${baseURL.replace(/\/$/, "")}/${url.replace(/^\//, "")}`;
  }

  request(url, method = "POST", data = null) {
    const token = storage.getItem("access_token");

    const headers = {
      Accept: "application/json",
      "Content-Type": "application/json",
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    };

    url = this.joinURL(this.domain, url);

    const options = {
      method,
      headers,
    };

    if (data) {
      options.body = JSON.stringify(data);
    }

    return fetch(url, options).then((res) => res.json());
  }

  get(url) {
    return this.request(url, "GET").catch((err) => err);
  }

  post(url, data) {
    return this.request(url, "POST", data).catch((err) => err);
  }

  put(url, data) {
    return this.request(url, "PUT", data).catch((err) => err);
  }

  delete(url) {
    return this.request(url, "DELETE").catch((err) => err);
  }

  patch(url, data) {
    return this.request(url, "PATCH", data).catch((err) => err);
  }

  postForm(url, formData) {
    const token = storage.getItem("access_token");
    const fullUrl = this.joinURL(this.domain, url);
    return fetch(fullUrl, {
      method: "POST",
      headers: {
        Accept: "application/json",
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
      },
      body: formData,
    }).then((res) => res.json());
  }
}

export default Service;

